import { ReactComponent as MetamaskLogo } from "../images/icons/provider/metamask.svg";
import { ReactComponent as TrustWalletLogo } from "../images/icons/provider/trustwallet.svg";
import { ProviderName, Logo } from "../components";

export const providerLogos: Record<ProviderName, Logo> = {
  MetaMask: MetamaskLogo,
  TrustWallet: TrustWalletLogo,
  Unknown: () => null,
};
